import React, { Component, useEffect, useState } from 'react';
import Visualisation from './main/visualisation.jsx';
import * as d3 from "d3";

function Main (props) {

    useEffect(() => {
    })

    return (
        <div id="main">
            <div id="header">
                <div>
                    <h4>The Gender Diamond</h4>
                    <h6 style={{marginTop: '0.25em'}}>Version 2</h6>
                    <h6>March 2025</h6>
                </div>
                <h4>Fe Simeoni</h4>
            </div>
            <Visualisation />
            <div id="footer" style={{backgroundImage:'url("./img/PNRR_loghi_black.png'}}></div>
        </div>
    )
}

export default Main;